import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import emailjs from 'emailjs-com';

const PHONE = '33695341985';
const EMAIL = 'kesneldigital@gmail.com';
const TIME_SLOTS = ['10:00', '11:00', '14:00', '16:00', '17:00'];

const S = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

const IconCalendar = () => (<svg viewBox="0 0 24 24" {...S} className="h-5 w-5"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>);
const IconMail = () => (<svg viewBox="0 0 24 24" {...S} className="h-5 w-5"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" /></svg>);
const IconMessage = () => (<svg viewBox="0 0 24 24" {...S} className="h-5 w-5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>);
const IconChevron = () => (<svg viewBox="0 0 24 24" {...S} className="h-4 w-4"><path d="m9 18 6-6-6-6" /></svg>);
const IconBack = () => (<svg viewBox="0 0 24 24" {...S} className="h-4 w-4"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>);
const IconClose = () => (<svg viewBox="0 0 24 24" {...S} className="h-5 w-5"><path d="M18 6 6 18M6 6l12 12" /></svg>);
const IconCheck = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="h-7 w-7"><path d="M20 6 9 17l-5-5" /></svg>);
const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5 fill-current"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /></svg>
);

function nextWeekdays(count) {
  const out = [];
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  while (out.length < count) {
    d.setDate(d.getDate() + 1);
    const dow = d.getDay();
    if (dow !== 0 && dow !== 6) out.push(new Date(d));
  }
  return out;
}

const ProjectModal = ({ isOpen, onClose }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [render, setRender] = useState(false);
  const [visible, setVisible] = useState(false);
  const [view, setView] = useState('hub'); // hub | book | success
  const [dayIdx, setDayIdx] = useState(null);
  const [time, setTime] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [note, setNote] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});

  const days = nextWeekdays(6);
  const locale = (i18n.language || 'en').startsWith('fr') ? 'fr-FR' : 'en-US';
  const dayLabel = (d) => d.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' });

  useEffect(() => {
    if (isOpen) {
      setRender(true);
      setView('hub');
      setError('');
      setFieldErrors({});
      setDayIdx(null); setTime(''); setFirstName(''); setLastName(''); setCompany(''); setPhone(''); setEmail(''); setNote(''); setSending(false);
      const id = requestAnimationFrame(() => setVisible(true));
      return () => cancelAnimationFrame(id);
    }
    setVisible(false);
    const id = setTimeout(() => setRender(false), 200);
    return () => clearTimeout(id);
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [isOpen, onClose]);

  if (!render) return null;

  const waUrl = `https://wa.me/${PHONE}?text=${encodeURIComponent(t('modal.whatsappText'))}`;
  const mailUrl = `mailto:${EMAIL}?subject=${encodeURIComponent(t('modal.emailSubject'))}`;

  const goMessage = () => { onClose(); navigate('/contact'); };

  const submitBooking = (e) => {
    e.preventDefault();
    const errs = {};
    if (dayIdx === null) errs.day = t('modal.dayRequired');
    if (!time) errs.time = t('modal.timeRequired');
    if (!firstName.trim()) errs.firstName = t('contact.required');
    if (!lastName.trim()) errs.lastName = t('contact.required');
    if (!phone.trim()) errs.phone = t('contact.required');
    if (!email.trim()) errs.email = t('contact.required');
    else if (!/^\S+@\S+\.\S+$/.test(email.trim())) errs.email = t('contact.invalidEmail');
    if (!note.trim()) errs.note = t('contact.required');

    if (Object.keys(errs).length > 0) {
      setFieldErrors(errs);
      return;
    }
    setFieldErrors({});
    setError('');
    setSending(true);
    const params = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_number: phone,
      message: `[${t('modal.bookTitle')}] ${dayLabel(days[dayIdx])} · ${time}\n${t('modal.company')}: ${company || '-'}\n\n${note}`,
    };
    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT,
        params,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(() => { setSending(false); setView('success'); })
      .catch(() => { setSending(false); setError(t('modal.errorText')); });
  };

  const chip = (active) =>
    `rounded-xl border px-3 py-2 text-sm font-semibold transition ${active ? 'border-brand-500 bg-brand-50 text-brand-700' : 'border-slatex-200 text-slatex-600 hover:border-brand-300'}`;
  const inputClass =
    'w-full rounded-xl border border-slatex-200 bg-white px-4 py-2.5 text-ink placeholder-slatex-400 transition focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-100';
  const fieldClass = (key) => `${inputClass}${fieldErrors[key] ? ' !border-red-400' : ''}`;
  const fieldError = (key) => fieldErrors[key] && <p className="mt-1 text-xs text-red-500">{fieldErrors[key]}</p>;

  const ChannelRow = ({ tile, icon, label, hint, ...rest }) => {
    const inner = (
      <>
        <span className={`flex h-11 w-11 flex-none items-center justify-center rounded-xl ${tile}`}>{icon}</span>
        <span className="flex-1 text-left">
          <span className="block text-sm font-bold text-ink">{label}</span>
          <span className="block text-xs text-slatex-500">{hint}</span>
        </span>
        <span className="text-slatex-300 group-hover:text-brand-500 transition"><IconChevron /></span>
      </>
    );
    const cls = 'group flex w-full items-center gap-4 rounded-2xl border border-slatex-200 bg-white p-3.5 transition hover:border-brand-300 hover:shadow-soft';
    if (rest.href) return (<a className={cls} {...rest}>{inner}</a>);
    return (<button type="button" className={cls} {...rest}>{inner}</button>);
  };

  return createPortal(
    <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center p-0 sm:p-4 transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`} role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={onClose} />

      <div className={`relative w-full sm:max-w-lg max-h-[92vh] overflow-y-auto rounded-t-3xl sm:rounded-3xl bg-white shadow-lift transition-all duration-200 ${visible ? 'translate-y-0 sm:scale-100 opacity-100' : 'translate-y-8 sm:translate-y-0 sm:scale-95 opacity-0'}`}>
        <button onClick={onClose} aria-label={t('modal.close')} className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full text-slatex-400 hover:bg-slatex-100 hover:text-ink transition">
          <IconClose />
        </button>

        {/* HUB */}
        {view === 'hub' && (
          <div className="p-6 sm:p-8">
            <span className="eyebrow">{t('navbar.cta')}</span>
            <h2 className="mt-2 text-2xl font-extrabold text-ink font-display">{t('modal.title')}</h2>
            <p className="mt-2 text-sm text-slatex-600">{t('modal.subtitle')}</p>

            <div className="mt-6 space-y-3">
              <ChannelRow tile="bg-brand-50 text-brand-600" icon={<IconCalendar />} label={t('modal.call')} hint={t('modal.callHint')} onClick={() => setView('book')} />
              <ChannelRow tile="bg-emerald-50 text-emerald-600" icon={<IconWhatsApp />} label={t('modal.whatsapp')} hint={t('modal.whatsappHint')} href={waUrl} target="_blank" rel="noreferrer" />
              <ChannelRow tile="bg-brand-50 text-brand-600" icon={<IconMail />} label={t('modal.email')} hint={t('modal.emailHint')} href={mailUrl} />
              <ChannelRow tile="bg-brand-50 text-brand-600" icon={<IconMessage />} label={t('modal.message')} hint={t('modal.messageHint')} onClick={goMessage} />
            </div>
          </div>
        )}

        {/* BOOKING */}
        {view === 'book' && (
          <form onSubmit={submitBooking} className="p-6 sm:p-8">
            <button type="button" onClick={() => setView('hub')} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slatex-500 hover:text-brand-700 transition">
              <IconBack /> {t('modal.back')}
            </button>
            <h2 className="mt-4 text-2xl font-extrabold text-ink font-display">{t('modal.bookTitle')}</h2>
            <p className="mt-2 text-sm text-slatex-600">{t('modal.bookSubtitle')}</p>

            <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-slatex-400">{t('modal.chooseDay')}</p>
            <div className="mt-3 flex flex-wrap gap-2">
              {days.map((d, i) => (
                <button type="button" key={i} onClick={() => { setDayIdx(i); }} className={chip(dayIdx === i)}>
                  {dayLabel(d)}
                </button>
              ))}
            </div>
            {fieldErrors.day && <p className="mt-2 text-sm text-red-500">{fieldErrors.day}</p>}

            <p className="mt-6 text-xs font-semibold uppercase tracking-wider text-slatex-400">{t('modal.chooseTime')}</p>
            <div className="mt-3 grid grid-cols-3 gap-2">
              {TIME_SLOTS.map((tt) => (
                <button type="button" key={tt} onClick={() => setTime(tt)} className={chip(time === tt)}>
                  {tt}
                </button>
              ))}
            </div>
            {fieldErrors.time && <p className="mt-2 text-sm text-red-500">{fieldErrors.time}</p>}

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <input className={fieldClass('firstName')} placeholder={t('modal.firstName')} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                {fieldError('firstName')}
              </div>
              <div>
                <input className={fieldClass('lastName')} placeholder={t('modal.lastName')} value={lastName} onChange={(e) => setLastName(e.target.value)} />
                {fieldError('lastName')}
              </div>
              <div>
                <input className={inputClass} placeholder={t('modal.company')} value={company} onChange={(e) => setCompany(e.target.value)} />
              </div>
              <div>
                <input className={fieldClass('phone')} type="tel" placeholder={t('modal.phone')} value={phone} onChange={(e) => setPhone(e.target.value)} />
                {fieldError('phone')}
              </div>
            </div>
            <div className="mt-3">
              <input className={fieldClass('email')} type="email" placeholder={t('modal.yourEmail')} value={email} onChange={(e) => setEmail(e.target.value)} />
              {fieldError('email')}
            </div>
            <div className="mt-3">
              <textarea className={`${fieldClass('note')} h-24 resize-none`} placeholder={t('modal.note')} value={note} onChange={(e) => setNote(e.target.value)} />
              {fieldError('note')}
            </div>

            {error && <p className="mt-3 text-sm font-medium text-red-500">{error}</p>}

            <button type="submit" disabled={sending} className="btn-primary mt-5 w-full disabled:opacity-60">
              {sending ? t('modal.sending') : t('modal.confirm')}
            </button>
          </form>
        )}

        {/* SUCCESS */}
        {view === 'success' && (
          <div className="p-8 text-center">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
              <IconCheck />
            </span>
            <h2 className="mt-5 text-2xl font-extrabold text-ink font-display">{t('modal.successTitle')}</h2>
            <p className="mt-3 text-slatex-600">{t('modal.successText')}</p>
            <button onClick={onClose} className="btn-primary mt-7">{t('modal.close')}</button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default ProjectModal;
